import { Box, Button, Text, VStack } from "@chakra-ui/react";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { themeConfig } from "..";
import { useAppSelector } from "../Hooks/useAppSelector";
import { getRole, getToken, selectAdminFetching } from "../Redux/AdminSlice";

function ActionBox(props: { text: string; to: string }) {
  const navigate = useNavigate();

  return (
    <Box>
      <Button
        w={200}
        h={20}
        bg={themeConfig.colors.green0}
        onClick={() => navigate(props.to)}
      >
        <Box>
          <Text>{props.text}</Text>
        </Box>
      </Button>
    </Box>
  );
}

const permissions = {
  sales: ["onboarding", "add-item"],
};

export function Home() {
  const token = useAppSelector<any>(getToken);
  const fetching = useAppSelector<boolean>(selectAdminFetching);
  const role = useAppSelector<string>(getRole);

  return (
    <Box p={3}>
      {!token ? (
        <Box>You are not autnenticated</Box>
      ) : (
        <VStack>
          <ActionBox text="On Board Store" to="/onboarding" />
          <ActionBox text="Add Item" to="/add-item" />
          {role !== "sales" && (
            <>
              <ActionBox text="Update Translations" to="/upload-translations" />
              <ActionBox text="Whatsapp Responses" to="/whatsapp-responses" />
            </>
          )}
          <ActionBox text="Market Scan" to="/market-scan" />
        </VStack>
      )}
    </Box>
  );
}
